<template>
    <heart-icon-styled :active="active" :animate="animate">
        <svg xmlns="http://www.w3.org/2000/svg" width="19.733" height="17.631" viewBox="0 0 19.733 17.631">
            <g transform="translate(247.101 -365.33)">
                <path
                    d="M-237.235,382.961a1.829,1.829,0,0,1-1.1-.362c-8.224-6.148-9-10.645-8.727-12.779a4.967,4.967,0,0,1,3.228-4.055,4.643,4.643,0,0,1,3.931,0,6.392,6.392,0,0,1,2.664,2.785,6.4,6.4,0,0,1,2.664-2.785,4.642,4.642,0,0,1,3.932,0h0a4.966,4.966,0,0,1,3.227,4.055c.271,2.133-.5,6.631-8.726,12.779A1.832,1.832,0,0,1-237.235,382.961Z"
                />
                <path
                    class="line"
                    d="M -237.2350769042969 381.5606689453125 C -237.1401672363281 381.5606689453125 -237.0481567382812 381.5309753417969 -236.9765777587891 381.4775085449219 C -233.5236053466797 378.8961181640625 -231.1146240234375 376.3902587890625 -229.8165283203125 374.0294799804688 C -228.7908630371094 372.1641540527344 -228.6981353759766 370.8066711425781 -228.8009643554688 369.9963989257812 C -228.9729461669922 368.6413269042969 -229.7923889160156 367.6261596679688 -231.1707458496094 367.0606079101562 C -231.7060089111328 366.8409729003906 -232.2166748046875 366.7296142578125 -232.6885986328125 366.7296142578125 C -233.1358489990234 366.7296142578125 -233.5508880615234 366.8259887695312 -233.9574737548828 367.0242309570312 C -234.9284057617188 367.4976501464844 -235.6052856445312 368.4764404296875 -236.0021514892578 369.2141723632812 L -237.235595703125 371.5071105957031 L -238.4682464599609 369.2137451171875 C -238.8646087646484 368.4762878417969 -239.541015625 367.4978332519531 -240.5122222900391 367.0244445800781 C -240.9190979003906 366.8262329101562 -241.3343048095703 366.7298889160156 -241.7816162109375 366.7298889160156 C -242.2534027099609 366.7298889160156 -242.7638092041016 366.8411560058594 -243.2987518310547 367.0606689453125 C -244.6769256591797 367.6260070800781 -245.4964752197266 368.6412658691406 -245.6688079833984 369.9966125488281 C -245.7717590332031 370.8067321777344 -245.6791381835938 372.1639709472656 -244.6533203125 374.0294189453125 C -243.3551330566406 376.3901672363281 -240.9459991455078 378.8960571289062 -237.4926605224609 381.4776000976562 C -237.4210357666016 381.5311584472656 -237.3295593261719 381.5606689453125 -237.2350769042969 381.5606689453125 M -237.2350769042969 382.9606628417969 C -237.6216125488281 382.9606628417969 -238.0085906982422 382.8399353027344 -238.3310546875 382.5988159179688 C -246.5552062988281 376.4508056640625 -247.3287506103516 371.95361328125 -247.0576324462891 369.8201293945312 C -246.8214111328125 367.9622802734375 -245.6755676269531 366.5224609375 -243.8300933837891 365.7654113769531 C -243.1224060058594 365.4750061035156 -242.4379272460938 365.3298950195312 -241.7816162109375 365.3298950195312 C -241.1244964599609 365.3298950195312 -240.4956207275391 365.4752502441406 -239.8990936279297 365.7658386230469 C -238.6276245117188 366.3855895996094 -237.7693328857422 367.5569458007812 -237.2350769042969 368.5509338378906 C -236.7003784179688 367.5569458007812 -235.8421173095703 366.3855895996094 -234.5710296630859 365.7658386230469 C -233.9745941162109 365.4750061035156 -233.3455047607422 365.3296203613281 -232.6885986328125 365.3296203613281 C -232.0318603515625 365.3296203613281 -231.3473052978516 365.4748840332031 -230.6392822265625 365.7654113769531 C -228.7941741943359 366.5224609375 -227.6479034423828 367.9622802734375 -227.412109375 369.8201293945312 C -227.1413726806641 371.95361328125 -227.9145050048828 376.4508056640625 -236.1383056640625 382.5988159179688 C -236.4611663818359 382.8399353027344 -236.8480987548828 382.9606628417969 -237.2350769042969 382.9606628417969 Z"
                />
            </g>
        </svg>
    </heart-icon-styled>
</template>
<script>
import styled, { css, keyframes } from "vue-styled-components";

const props = {
    active: Boolean,
    animate: Boolean
};

const BounceAnimate = keyframes`
    100% {
        transform: scale(1);
    } 90% {
        transform: scale(0.95);
    } 75% {
        transform: scale(1.15);
    } 60% {
        transform: scale(0.9);
    } 45% {
        transform: scale(1.25);
    } 30% {
        transform: scale(0.85);
    } 15% {
        transform: scale(1.35);
    } 0 % {
        transform: scale(1);
    }
`;

const HeartIconStyled = styled("div", props)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.8rem;
    transform: scale(1);

    svg {
        fill: transparent;

        .line {
            fill: #5e616e;
        }
    }

    ${props =>
        props.active &&
        css`
            svg {
                fill: ${props.theme.color.pink};

                .line {
                    fill: ${props.theme.color.pink};
                }
            }
        `}

    ${props =>
        props.animate &&
        css`
            animation: ${BounceAnimate} 1s ease-out backwards;
        `}
`;

export default {
    name: "HeartIcon",
    data: () => ({
        animate: false
    }),
    props: {
        active: Boolean
    },
    methods: {
        animation() {
            this.animate = true;
            setTimeout(() => {
                this.animate = false;
            }, 1000);
        }
    },
    watch: {
        active(nval, oval) {
            if (nval) {
                this.animation();
            }
        }
    },
    mounted() {
        this.active;
    },
    components: {
        HeartIconStyled
    }
};
</script>
